<template>
	<main>
		<HeaderTab :title="$t('contact.title')" />
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12 col-lg-6 mb-4">
						<div class="h-100">
							<h4 class="mb-3">
								<font-awesome-icon :icon="['fal', 'phone']" class="mr-2" />
								{{ $t('contact.contactus_title') }}
							</h4>
							<div v-if="contactus_content" v-html="contactus_content"></div>
							<p v-else class="text-muted">{{ $t('contact.no_content') }}</p>
						</div>
					</div>

					<div class="col-12 col-lg-6 mb-4">
						<div class="h-100">
							<h4 class="mb-3">
								<font-awesome-icon :icon="['fal', 'calendar']" class="mr-2" />
								{{ $t('contact.openhours_title') }}
							</h4>
							<table v-if="openDays.some(h => h)" class="table table-borderless mb-0">
								<tbody>
									<tr v-for="(hours, idx) in openDays" :key="idx">
										<td class="pl-0">{{ day_names[idx] }}</td>
										<td class="text-right pr-0">{{ hours }}</td>
									</tr>
								</tbody>
							</table>
							<p v-else class="text-muted">{{ $t('contact.no_content') }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Contract from '@/mixins/Contract.js'
import xss from 'xss'

export default {
	name: 'ContactUs',
	mixins: [Contract],
	data() {
		return {
			contactus_fr: '',
			contactus_en: '',
			openDays: [],
		}
	},
	computed: {
		/** Contenu HTML de la page Contact selon la langue active (fr/en), sanitisé contre le XSS. */
		contactus_content() {
			const lang = this.getConfig('lang') ?? 'fr'
			const raw = lang === 'en' ? this.contactus_en : this.contactus_fr
			return xss(raw)
		},
		/** Noms localisés des jours de la semaine (lundi → dimanche) via i18n. */
		day_names() {
			return [0, 1, 2, 3, 4, 5, 6].map(i => this.$t(`contact.days.${i}`))
		},
	},
	created() {
		this.init_component()
	},
	methods: {
		/**
		 * Charge les données de contact depuis la configuration de la politique de confidentialité :
		 * contenu HTML FR/EN et horaires d'ouverture.
		 */
		async init_component() {
			const data = await this.contractPrivacyPolicy()
			if (!data) return
			this.contactus_fr = data.contactus_fr || ''
			this.contactus_en = data.contactus_en || ''
			const days = data.openDays
			if (Array.isArray(days)) {
				this.openDays = days
			} else if (days) {
				try { this.openDays = JSON.parse(days) } catch { this.openDays = [] }
			}
		},
	},
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
	},
}
</script>
